// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface SuitcaseIconSignature {
  Element: SVGSVGElement;
}

export const SuitcaseIcon: TOC<SuitcaseIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M20 8H16.899C16.435 5.721 14.415 4 12 4C9.585 4 7.565 5.721 7.101 8H4C2.897 8 2 8.896 2 10V20C2 21.103 2.897 22 4 22H20C21.103 22 22 21.103 22 20V10C22 8.896 21.103 8 20 8ZM12 6C13.304 6 14.416 6.836 14.829 8H9.171C9.584 6.836 10.696 6 12 6ZM4 10V20H20.001L20 10H4ZM6 12H8V18H6V12ZM18 12H16V18H18V12Z"/>
</svg>
</template>;